import { render, staticRenderFns } from "./DataDemo.vue?vue&type=template&id=0d7c4522&scoped=true&"
import script from "./DataDemo.vue?vue&type=script&lang=js&"
export * from "./DataDemo.vue?vue&type=script&lang=js&"
import style0 from "./DataDemo.vue?vue&type=style&index=0&id=0d7c4522&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7c4522",
  null
  
)

export default component.exports